import * as React from "react"
import { Link } from "gatsby"

const FAQs = ({ className }) => {
  const FAQuestions = [
    {
      question: "How do I find jewelry buyers near me to sell my Rolex or watch?",
      answer:
        "To find jewelry buyers near you for selling your Rolex or watch, you can search online directories or platforms that specialize in buying and selling jewelry. Look for reputable buyers in your area and contact them through their provided contact information to inquire about selling your Rolex or watch.",
    },
    {
      question: "How can I sell my Rolex or watch near me?",
      answer:
        "To sell your Rolex or watch locally, you can visit jewelry stores, pawnshops, or luxury watch dealers in your area. It's recommended to research and find trustworthy buyers who have a good reputation and offer fair prices.",
    },
    {
      question: "Where can I find watch buyers near me?",
      answer:
        "To find watch buyers near your location, you can utilize online resources such as search engines or directories. Look for reputable watch buyers or luxury watch dealers operating in your area. Contact them directly to discuss selling your watch.",
    },
    {
      question: "How do I choose the right jewelry buyer?",
      answer:
        "Choosing the right jewelry buyer is important for a fair and smooth selling experience. Consider factors such as their reputation, customer reviews, expertise in evaluating jewelry, and transparency in the selling process. It's also beneficial to compare offers from multiple buyers to get the best possible price for your jewelry.",
    },
    {
      question: "Where can I sell my watch?",
      answer:
        "You can sell your watch to local jewelry stores, luxury watch dealers, online marketplaces, or through classified ads. Each option has its pros and cons, so consider factors like convenience, speed of sale, and the price you can get for your watch.",
    },
    {
      question: "Can I sell my jewelry near me?",
      answer:
        "Yes, you can sell your jewelry near you by visiting local jewelry buyers, pawnshops, or consignment stores. Additionally, you can explore online platforms that facilitate the selling process, where you can connect with potential buyers and sell your jewelry from the comfort of your own home.",
    },
    {
      question: "Where can I sell my watch near me?",
      answer:
        "To sell your watch near you, you can consider options like local watch buyers, luxury watch dealers, or even online marketplaces that cater to watch enthusiasts. Research reputable buyers or platforms that provide secure transactions and fair prices for your watch.",
    },
    {
      question: "How can I find a reliable watch buyer?",
      answer:
        "Finding a reliable watch buyer involves researching their reputation, customer feedback, and industry experience. Look for watch buyers who specialize in luxury timepieces and have a track record of offering competitive prices and excellent customer service. Additionally, consider their authentication process and payment methods to ensure a secure transaction.",
    },
    {
      question: "Are you a Rolex buyer or only interested in specific brands?",
      answer:
        "As jewelry buyers, we are interested in a wide range of luxury brands, including Rolex. We evaluate each watch individually based on its brand, model, condition, and market demand. Whether you have a Rolex or another high-end watch, we are open to buying it if it meets our criteria for quality and authenticity.",
    },
    {
      question: "Do you buy silver jewelry or only specific metals?",
      answer:
        "We buy a variety of jewelry pieces, including silver jewelry. While we specialize in luxury watches and fine jewelry, we also consider silver pieces based on their craftsmanship, design, and condition. If you have silver jewelry that you wish to sell, we are interested in assessing its value and making an offer.",
    },
  ]

  const FAQCard = ({ question, answer }) => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-5 group">
        <h3 className="text-2xl text-gray-600 group-hover:text-accent uppercase col-span-1 md:col-span-2">
          {question}
        </h3>
        <p className="flex justify-start h-full col-span-1 md:col-span-2">{answer}</p>
      </div>
    )
  }

  return (
    <section className={" " + className}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-4xl text-black uppercase text-center">
              Frequently Asked Questions
            </h2>
          </div>
          {FAQuestions.map((item, index) => (
            <FAQCard key={index} question={item.question} answer={item.answer} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQs
